import { RouteProps } from 'react-router-dom';
import { demoPagesMenu, landingPagesMenu, pageLayoutTypesPagesMenu } from '../menu';
import DefaultAside from '../pages/_layout/_asides/DefaultAside';

const asides: RouteProps[] = [
	{ path: demoPagesMenu.login.path, element: null },
	{ path: demoPagesMenu.signUp.path, element: null },
	{ path: pageLayoutTypesPagesMenu.blank.path, element: null },
	{ path: landingPagesMenu.home.path, element: null },
	{ path: landingPagesMenu.policy.path, element: null },
	{ path: landingPagesMenu.contact.path, element: null },
	{ path: landingPagesMenu.pricing.path, element: null },
	{ path: '*', element: <DefaultAside /> },
];

export default asides;
